import { getArrayDisplayValues } from "../../../../formatting/array-manipulation";
import {
  getCountryNameValues,
  getAssessmentMethodologyDisplayValue,
} from "../../../../formatting/domain-value-manipulation";
import Reference from "../../common/Reference";
import Section from "../../common/Section/Section";
import type { Field, SectionComponentProps } from "../../types";
import keyInformation from "../references/key-information.png";

function KeyInformation({ details, onEdit }: SectionComponentProps) {
  const { interventionType, country, programmeInfo, assessmentMethodology } =
    details;

  const fields: Array<Field> = [
    {
      name: "Intervention Type",
      type: "text",
      index: 0,
      value: interventionType,
    },
    {
      name: "Country",
      type: "text",
      index: 1,
      value: getCountryNameValues(country),
    },
    {
      name: "Credit Type (Asset type)",
      type: "text",
      index: 2,
      value: programmeInfo?.assetType,
    },
    {
      name: "Assessment Methodology",
      type: "text",
      index: 3,
      value: getAssessmentMethodologyDisplayValue(assessmentMethodology),
    },
    {
      name: "Standard (Carbon Credit Programme)",
      type: "text",
      index: 4,
      fullLine: true,
      value: getArrayDisplayValues(programmeInfo?.carbonCreditProgramme),
    },
  ];

  return (
    <Section
      title="Key information"
      columns={2}
      fields={fields}
      onEdit={() => onEdit("key-information")}
      reference={[
        {
          type: "image",
          place: "beneath",
          index: 0,
          item: (
            <Reference
              image={keyInformation}
              radius="25px"
              alt="Earthly key information reference"
              testId="key-information-reference"
            />
          ),
        },
      ]}
    />
  );
}

export default KeyInformation;
